/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Body_patch_tournament_pdf_tournament_pdf__tournament_id__patch = {
    properties: {
        pdf: {
            type: 'binary',
            isRequired: true,
            format: 'binary',
        },
    },
} as const;
